module.exports = __webpack_public_path__ + "img/icon4.81c622ec.svg";